import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('wizard.package.pack_1'),
      createNewClient: true,
    },
    {
      id: 2,
      name: i18n.t('wizard.package.pack_2'),
      createNewClient: true,
    },
    {
      id: 3,
      name: i18n.t('wizard.package.pack_3'),
      createNewClient: true,
    },
    {
      id: 4,
      name: i18n.t('wizard.package.pack_4'),
    },
    {
      id: 5,
      name: i18n.t('wizard.package.pack_5'),
    },
    {
      id: 6,
      name: i18n.t('wizard.package.pack_6'),
    },
    {
      id: 7,
      name: i18n.t('wizard.package.pack_7'),
      createNewClient: true,
    },
    {
      id: 8,
      name: i18n.t('wizard.package.pack_8'),
      createNewClient: true,
    },
    {
      id: 9,
      name: i18n.t('wizard.package.pack_9'),
      createNewClient: true,
    },
    {
      id: 10,
      name: i18n.t('wizard.package.pack_10'),
      // createNewClient: true,
    },
  ]
}

export function TIPOS_PAQUETES_CONTRATACION (state) {
  return configHelper.getConfig(state, 'TIPOS_PAQUETES_CONTRATACION', GenerateConfig)
}

